import { render, staticRenderFns } from "./MoneyFormat.vue?vue&type=template&id=5305de44&"
import script from "./MoneyFormat.vue?vue&type=script&lang=js&"
export * from "./MoneyFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports